import { lazy } from 'react';

/** Core explore */
export const Home = lazy(() => import('../../components/Home'));
export const Forts = lazy(() => import('../../components/Forts'));
export const FortDetail = lazy(() => import('../../components/FortDetail'));
export const Temples = lazy(() => import('../../components/Temples'));
export const TempleDetail = lazy(() => import('../../components/Temples/TempleDetail'));
export const Wades = lazy(() => import('../../components/Wades'));
export const WadaDetail = lazy(() => import('../../components/WadaDetail'));
export const SearchResults = lazy(() => import('../../components/Search/SearchResults'));
export const NearbyForts = lazy(() => import('../../components/NearbyForts'));

/** Info & auth */
export const About = lazy(() => import('../../components/Info/About'));
export const Contact = lazy(() => import('../../components/Info/Contact'));
export const EmergencyHubPage = lazy(() => import('../../components/Info/EmergencyHubPage'));
export const RegisterPage = lazy(() => import('../../components/Auth/RegisterPage'));
export const LoginPage = lazy(() => import('../../components/Auth/LoginPage'));

/** Blog */
export const BlogPage = lazy(() => import('../../components/Blog/BlogPage'));
export const BlogDetail = lazy(() => import('../../components/Blog/BlogDetail'));

/** Heritage */
export const HeritageHub = lazy(() => import('../../components/Heritage/HeritageHub'));
export const BhaktaGadkotHub = lazy(() => import('../../components/Heritage/BhaktaGadkotHub'));
export const SardarsHub = lazy(() => import('../../components/Heritage/SardarsHub'));
export const SardarDetail = lazy(() => import('../../components/Heritage/SardarDetail'));
export const HistoricPlacesHub = lazy(() => import('../../components/Heritage/HistoricPlacesHub'));
export const HistoricPlaceDetail = lazy(() => import('../../components/Heritage/HistoricPlaceDetail'));
export const HeritagePartners = lazy(() => import('../../components/Heritage/HeritagePartners'));
export const VisitPlanningHub = lazy(() => import('../../components/Heritage/VisitPlanningHub'));
export const BookingLookup = lazy(() => import('../../components/Heritage/BookingLookup'));

/** History & maps */
export const HistoryPage = lazy(() => import('../../components/History/HistoryPage'));
export const TithiYearCalendar = lazy(() => import('../../components/History/TithiYearCalendar'));
export const TithiHistoryCompendium = lazy(() => import('../../components/History/TithiHistoryCompendium'));
export const IndiaHistoricMapPage = lazy(() => import('../../components/History/IndiaHistoricMapPage'));
export const HistoryDetail = lazy(() => import('../../components/History/HistoryDetail'));
export const DailyHistoryDetail = lazy(() => import('../../components/History/DailyHistoryDetail'));
export const TodayHistoryPopup = lazy(() => import('../../components/History/TodayHistoryPopup'));

/** Geographic */
export const GeographicExplorer = lazy(() => import('../../components/Geographic/GeographicExplorer'));
export const ThematicRoutes = lazy(() => import('../../components/Geographic/ThematicRoutes'));
export const ThematicRouteDetail = lazy(() => import('../../components/Geographic/ThematicRouteDetail'));

/** Organizations & events */
export const OrganizationsPage = lazy(() => import('../../components/Organizations/OrganizationsPage'));
export const OrganizationDetail = lazy(() => import('../../components/Organizations/OrganizationDetail'));
export const OrganizationRepPortalPage = lazy(() => import('../../components/Organizations/OrganizationRepPortalPage'));
export const EventsCalendarPage = lazy(() => import('../../components/Events/EventsCalendarPage'));

/** Shop */
export const ShopPage = lazy(() => import('../../components/Shop/ShopPage'));
export const ShopProductDetail = lazy(() => import('../../components/Shop/ShopProductDetail'));
export const ShopCheckoutPage = lazy(() => import('../../components/Shop/ShopCheckoutPage'));
export const ShopOrderSuccess = lazy(() => import('../../components/Shop/ShopOrderSuccess'));

/** Community & tools */
export const CommunityHubPage = lazy(() => import('../../components/Community/CommunityHubPage'));
export const FortGuidePage = lazy(() => import('../../components/FortGuidePage'));
export const TrekPlanner = lazy(() => import('../../components/TrekPlanner'));
export const TrekLiveShare = lazy(() => import('../../components/Trek/TrekLiveShare'));
export const UserContributions = lazy(() => import('../../components/UserContributions'));
export const Quiz = lazy(() => import('../../components/Quiz'));
export const ShortNotes = lazy(() => import('../../components/ShortNotes'));
export const LearnSection = lazy(() => import('../../components/LearnSection'));
export const InstitutionPortalPage = lazy(() => import('../../components/Education/InstitutionPortalPage'));
export const AudiobookLibraryPage = lazy(() => import('../../components/Education/AudiobookLibraryPage'));
export const BadgesSystem = lazy(() => import('../../components/BadgesSystem'));
export const WeaponsList = lazy(() => import('../../components/Weapons/WeaponsList'));
export const WeaponDetails = lazy(() => import('../../components/Weapons/WeaponDetails'));

/** User */
export const UserProfile = lazy(() => import('../../components/User/UserProfile'));
export const WishlistManager = lazy(() => import('../../components/User/WishlistManager'));
export const VisitPlanner = lazy(() => import('../../components/User/VisitPlanner'));
export const SharedTripPlan = lazy(() => import('../../components/User/SharedTripPlan'));

/** Errors */
export const ErrorPage = lazy(() => import('../../components/Error/ErrorPage'));
export const HeritageGalleryPage = lazy(() => import('../../components/Gallery/HeritageGalleryPage'));
export const BooksLibraryPage = lazy(() => import('../../components/Books/BooksLibraryPage'));
export const BookReaderPage = lazy(() => import('../../components/Books/BookReaderPage'));
